import { doodBlockConfig, propertyValue } from "./dood-block-config";
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from "./descriptor-field-order";
import type { IBlockDescriptor } from "./descriptor";

export const KIOSKDOUBLEBUTTONFOOTERBLOCK_LEGACY_FIELD_ORDER = [
  "primary_button_background_color",
  "primary_button_text_color",
  "primary_button_label",
  "primary_button_link",
  { type: "separator" },
  "secondary_button_background_color",
  "secondary_button_text_color",
  "secondary_button_label",
  "secondary_button_link",
  { type: "separator" },
  "background_color",
  "text_color",
  "display_second_button",
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  kioskDoubleButtonFooterBlockDescriptor: _generatedKioskDoubleButtonFooterBlockDescriptor,
  kioskDoubleButtonFooterBlockBlocDefinition,
  kioskDoubleButtonFooterBlockDashboardLayout,
  kioskDoubleButtonFooterBlockConfig,
  kioskDoubleButtonFooterBlockResolveConfig,
  kioskDoubleButtonFooterBlockProperties,
} = doodBlockConfig(
  {
    hideFromPicker: true,
    name: "Kiosk - Double Button Footer",
    componentType: "KioskDoubleButtonFooterBlockComponent",
    category: "kiosk",
    description: "Kiosk - Double Button Footer.",
    keywords: [],
    allowed_in: ["KioskLoyaltyConnectionPage"],
    sharedFields: {},
  },

  () => ({
    primary_button_background_color: propertyValue({
      type: "color",
      value: { type: "palette", value: "neutral-600" },
      options: {
        label:
          "pages.blocks.kiosk-double-button-footer.primary-button-background-color.label",
      },
    }),
    primary_button_text_color: propertyValue({
      type: "color",
      value: { type: "palette", value: "neutral-50" },
      options: {
        label:
          "pages.blocks.kiosk-double-button-footer.primary-button-text-color.label",
      },
    }),
    primary_button_label: propertyValue({
      type: "text",
      value: "",
      options: {
        label:
          "pages.blocks.kiosk-double-button-footer.primary-button-label.label",
      },
    }),
    primary_button_link: propertyValue({
      type: "text",
      value: "",
      options: {
        label:
          "pages.blocks.kiosk-double-button-footer.primary-button-link.label",
        help: "pages.blocks.kiosk-double-button-footer.primary-button-link.help",
      },
    }),
    secondary_button_background_color: propertyValue({
      type: "color",
      value: { type: "palette", value: "neutral-50" },
      options: {
        label:
          "pages.blocks.kiosk-double-button-footer.secondary-button-background-color.label",
      },
    }),
    secondary_button_text_color: propertyValue({
      type: "color",
      value: { type: "palette", value: "neutral-600" },
      options: {
        label:
          "pages.blocks.kiosk-double-button-footer.secondary-button-text-color.label",
      },
    }),
    secondary_button_label: propertyValue({
      type: "text",
      value: "",
      options: {
        label:
          "pages.blocks.kiosk-double-button-footer.secondary-button-label.label",
      },
    }),
    secondary_button_link: propertyValue({
      type: "text",
      value: "",
      options: {
        label:
          "pages.blocks.kiosk-double-button-footer.secondary-button-link.label",
        help: "pages.blocks.kiosk-double-button-footer.secondary-button-link.help",
      },
    }),
    background_color: propertyValue({
      type: "color",
      value: { type: "hex", value: "#FFFFFF" },
      options: {
        label: "pages.blocks.kiosk-double-button-footer.background-color.label",
      },
    }),
    text_color: propertyValue({
      type: "color",
      value: { type: "hex", value: "#000" },
      options: {
        label: "pages.blocks.kiosk-double-button-footer.text-color.label",
      },
    }),
    display_second_button: propertyValue({
      type: "checkbox",
      value: true,
      options: {
        label:
          "pages.blocks.kiosk-double-button-footer.display-second-button.label",
      },
    }),
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.kiosk-double-button-footer.tab.content.label",
        fieldsets: [
          {
            legend:
              "pages.blocks.kiosk-double-button-footer.fieldset.appearance.label",
            fields: ["background_color", "text_color"],
          },
          {
            legend:
              "pages.blocks.kiosk-double-button-footer.fieldset.primary-button.label",
            fields: [
              "primary_button_label",
              "primary_button_link",
              "primary_button_background_color",
              "primary_button_text_color",
            ],
          },
          {
            legend:
              "pages.blocks.kiosk-double-button-footer.fieldset.secondary-button.label",
            fields: [
              "display_second_button",
              {
                prop: "secondary_button_label",
                visibleWhen: { display_second_button: true },
              },
              {
                prop: "secondary_button_link",
                visibleWhen: { display_second_button: true },
              },
              {
                prop: "secondary_button_background_color",
                visibleWhen: { display_second_button: true },
              },
              {
                prop: "secondary_button_text_color",
                visibleWhen: { display_second_button: true },
              },
            ],
          },
        ],
      },
    ],
  }),
);

export function kioskDoubleButtonFooterBlockDescriptor(): IBlockDescriptor;
export function kioskDoubleButtonFooterBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function kioskDoubleButtonFooterBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedKioskDoubleButtonFooterBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(
    _generatedKioskDoubleButtonFooterBlockDescriptor,
    kioskDoubleButtonFooterBlockProperties,
    fieldOrder,
  );
}

export {
  kioskDoubleButtonFooterBlockBlocDefinition,
  kioskDoubleButtonFooterBlockDashboardLayout,
  kioskDoubleButtonFooterBlockProperties,
  kioskDoubleButtonFooterBlockConfig,
  kioskDoubleButtonFooterBlockResolveConfig,
};

export type KioskDoubleButtonFooterBlockConfig =
  typeof kioskDoubleButtonFooterBlockConfig;
